import dynamic from 'next/dynamic';
import { NextSeo } from 'next-seo';
import { useTranslation } from 'next-i18next/pages';

const ReferralCodeForm = dynamic(() =>
  import('features/referral-code').then((mod) => mod.ReferralCodeForm),
);

const ReferralCodePage = () => {
  const { t } = useTranslation();

  return (
    <>
      <NextSeo title={t('Referral Code')} />
      <ReferralCodeForm />
    </>
  );
};

export { getServerSideProps } from 'getServerSideProps';
export default ReferralCodePage;
